<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>공지사항 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="aRow5">
                            <div class="flex flexAlignS bdBttom">
                                <div class="detailInputBox">
                                    <label>제목</label>
                                    <input id='title' placeholder="제목을 작성해주세요."  />
                                </div>
                                <div class="detailInputBox flex flexAlignC">
                                    <label>첨부파일</label>
                                    <div class="detailFileInputBox">
                                        <input class="upload-name" value="파일선택" disabled="disabled" >
                                        <label for="input-file">업로드</label>
                                        <input type="file" id="input-file" class="upload-hidden">
                                    </div>
                                </div>
                            </div>
                            <div class="detailTxtBox">
                                <form action="">
                                    <textarea name="" id="" class="detailTxtBoxItem" placeholder="내용을 입력해주세요."></textarea>
                                </form>
                            </div>
                        </div>

                        <div class="btnBox">
                            <button @click="listBtnGo()" class="redborderBtn">취 소</button>
                            <button class="redBtn">수 정</button>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>

export default {
    name: 'Home',
    methods:{
        goback(){
            this.$router.go(-1) 
        }
    }
}
</script>

<style scoped lang="scss">

</style>